module.exports = __webpack_public_path__ + "img/table_light_orange.6a20ad38.svg";